<template>
  <fragment>
    <div class="bootstrap-tagsinput border-0 p-1">
      <span class="tag taglist label label-info"  v-for="(v,index) in value" :key="index"
        :style="value[index].type.backgroundColor|tagtypecss" :title="value[index].description">
       {{value[index].description}}
       
      </span>
     
    </div>
   
  </fragment>
</template>
<style scoped>
.bootstrap-tagsinput .taglist {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
    display: inline-block;
}
</style>
<script>

export default {
  name: "tags",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: Array,
      required: false,
    },
    readOnlyReserved: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  components: {},
  data() {
    return {
      options: [],
      selectedTag: null,
    };
  },
  methods: {
    setVisibility(tag) {
      if (this.readOnly) return false;
      if (this.readOnlyReserved && tag.type.reserved) return false;
      return true;
    },

  }
  
};
</script>

<style lang="css">
.tag-remove {
  cursor: pointer;
}

.bootstrap-tagsinput .v-select {
    display: inline-block;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    padding: 0 6px;
    /* margin: 0; */
    width: auto;
    /* max-width: 100%; */
    min-width: 30%;
}
</style>
